import BaseServiceV2 from "../BaseServiceV2";
import ApiUrl from '../ApiUrl';

class AdayTestYanitlarService extends BaseServiceV2 {

    constructor() {
        super(ApiUrl.IKTestMerkeziDomain + ApiUrl.controller.AdayTestYanitlar);
    }

    // Her cevap için ayrı create çağrısı, token ile
    createAnswer = async (answerData, token) => {
        try {
            // BaseServiceV2'deki create metodu token almadığı için easyPost kullanıyoruz
            const response = await this.easyPost(this.ApiUrl.endpoint.Create, answerData, token);
            return response;
        } catch (error) {
            console.error('Cevap kaydedilirken hata:', error);
            throw error;
        }
    }

    // Toplu cevap kaydetme - backend bulk desteklemediği için foreach döngüsü
    saveAnswers = async (answers, token) => {
        try {
            const results = [];
            
            for (const answer of answers) {
                // Her cevap için token ile ayrı istek atıyoruz
                const result = await this.createAnswer(answer, token);
                results.push(result);
                
                // Eğer herhangi bir cevap kaydedilemezse durduralım
                if (!result || !result.isSuccess) {
                    throw new Error(`Cevap kaydedilemedi: ${JSON.stringify(answer)}`);
                }
            }
            
            return {
                isSuccess: true,
                resultObject: results,
                message: 'Tüm cevaplar başarıyla kaydedildi'
            };
            
        } catch (error) {
            console.error('Cevaplar kaydedilirken hata:', error);
            return {
                isSuccess: false,
                message: error.message
            };
        }
    }

}

const adayTestYanitlarService = new AdayTestYanitlarService();

export default adayTestYanitlarService; 